import { render, staticRenderFns } from "./OrderShipmentItems.vue?vue&type=template&id=7b41fadf&"
import script from "./OrderShipmentItems.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports